const resourcePath = 'resource/'

const resourceOriginPath = 'origin-resource/'

function getCommonPath() {
  return `${resourcePath}common/`
}

function getConfigPath() {
  return `${resourcePath}config/`
}

function getGamePath() {
  return `${resourcePath}game/`
}

function getAudioPath() {
  return `${getGamePath()}audio/`
}

function getVideoPath() {
  return `${getGamePath()}video/`
}

function getTexturePath() {
  return `${getGamePath()}texture/`
}

export default {
  /**
   * common 目录是公共资源目录，非标准包且是分场景制作的素材包才有该目录
   * @constructor
   */
  get COMMON_PATH(): string {
    return getCommonPath()
  },

  get MAIN_PATH(): string {
    return getGamePath()
  },
  get PROJECT_BASIC_PATH(): string {
    return '/project/preview/'
  },
  get AUDIO_BASIC_PATH(): string {
    return `${getAudioPath()}`
  },
  get VIDEO_BASIC_PATH(): string {
    return `${getVideoPath()}`
  },
  get FONT_BASIC_PATH(): string {
    return `${resourcePath}font/`
  },
  get TEXTURE_BASIC_PATH(): string {
    return `${getTexturePath()}`
  },

  // 资源
  get LANGUAGES_JSON(): string {
    return `${getConfigPath()}languages.json`
  },
  // 当删除背景图片或背景音乐时，使用默认的图片与背景音乐替换，因为素材包的逻辑强依赖于背景图片和背景音乐
  get BG_IMG_DEFAULT(): string {
    return `${getTexturePath()}pb_bg0.jpg`
  },
  get BGM_DEFAULT(): string {
    return `${getAudioPath()}bm_bgm0.mp3`
  },

  get GLOBAL_URL_MAP(): string {
    return `Assets/meta/globalUrlMap.js`
  },

  get EDITOR_CONFIG(): string {
    return 'editorConfig.json'
  },

  // 临时配置项，仅用于平台制作使用，打包可移除
  get TEMP_CONFIG(): string {
    return 'tempConfig.json'
  },

  get GAME_CONFIG(): string {
    return `${getConfigPath()}gameConfig.json`
  },

  get ORIGIN_RESOURCE_PATH(): string {
    return resourceOriginPath
  },

  WHITE_LIST_RES: `${getConfigPath()}whiteListRes.txt`, // 资源白名单,用于多语言发布,后端发布时只消费这个白名单
  WHITE_LIST_RES_GAME: `${getConfigPath()}whiteListResGame.txt`, // 游戏页面资源白名单
  WHITE_LIST_RES_ENDING: `${getConfigPath()}whiteListResEnding.txt`, // 结束页面资源白名单
  NODE_UUID2RES: `nodeUuid2Res.txt`, // 节点对应的资源路径列表，用于加载游戏后丢失资源兜底恢复
  BRAIN: `${getConfigPath()}brain.json`, // 脑图数据json文件
}
